const options = {
    Face: [
      { name: "Face Shape 1", svg: require('./svgs/Heads/Head 1.svg').default },
      { name: "Face Shape 2", svg: require('./svgs/Heads/Head 2.svg').default },
      { name: "Face Shape 3", svg: require('./svgs/Heads/Head 3.svg').default },
      { name: "Face Shape 4", svg: require('./svgs/Heads/Head 4.svg').default },
      { name: "Face Shape 5", svg: require('./svgs/Heads/Head 5.svg').default },
      { name: "Face Shape 6", svg: require('./svgs/Heads/Head 6.svg').default },
      { name: "Face Shape 7", svg: require('./svgs/Heads/Head 7.svg').default },
    ],
    Eyes: [
        { name: "Eyes 1", svg: require('./svgs/Eyes/Eyes 1.svg').default },
        { name: "Eyes 2", svg: require('./svgs/Eyes/Eyes 2.svg').default },
        { name: "Eyes 3", svg: require('./svgs/Eyes/Eyes 3.svg').default },
        { name: "Eyes 4", svg: require('./svgs/Eyes/Eyes 4.svg').default },
        { name: "Eyes 5", svg: require('./svgs/Eyes/Eyes 5.svg').default },
        { name: "Eyes 6", svg: require('./svgs/Eyes/Eyes 6.svg').default },
        { name: "Eyes 7", svg: require('./svgs/Eyes/Eyes 7.svg').default },
        { name: "Eyes 8", svg: require('./svgs/Eyes/Eyes 8.svg').default },
        { name: "Eyes 9", svg: require('./svgs/Eyes/Eyes 9.svg').default },
        { name: "Eyes 10", svg: require('./svgs/Eyes/Eyes 10.svg').default },
        { name: "Eyes 11", svg: require('./svgs/Eyes/Eyes 11.svg').default },
        { name: "Eyes 12", svg: require('./svgs/Eyes/Eyes 12.svg').default },
        { name: "Eyes 13", svg: require('./svgs/Eyes/Eyes 13.svg').default },
        { name: "Eyes 14", svg: require('./svgs/Eyes/Eyes 14.svg').default },
      ],
    Mouth : [
        { name: "Mouth 1", svg: require('./svgs/Mouths/Mouth 1.svg').default },
        { name: "Mouth 2", svg: require('./svgs/Mouths/Mouth 2.svg').default },
        { name: "Mouth 3", svg: require('./svgs/Mouths/Mouth 3.svg').default },
        { name: "Mouth 4", svg: require('./svgs/Mouths/Mouth 4.svg').default },
        { name: "Mouth 5", svg: require('./svgs/Mouths/Mouth 5.svg').default },
        { name: "Mouth 6", svg: require('./svgs/Mouths/Mouth 6.svg').default },
        { name: "Mouth 7", svg: require('./svgs/Mouths/Mouth 7.svg').default },
        { name: "Mouth 8", svg: require('./svgs/Mouths/Mouth 8.svg').default },
        { name: "Mouth 9", svg: require('./svgs/Mouths/Mouth 9.svg').default },
        { name: "Mouth 10", svg: require('./svgs/Mouths/Mouth 10.svg').default },
        { name: "Mouth 11", svg: require('./svgs/Mouths/Mouth 11.svg').default },
        { name: "Mouth 12", svg: require('./svgs/Mouths/Mouth 12.svg').default },
        { name: "Mouth 13", svg: require('./svgs/Mouths/Mouth 13.svg').default },
        { name: "Mouth 14", svg: require('./svgs/Mouths/Mouth 14.svg').default },
    ]
};

export default options;

